import React from 'react';
import { Dialog, DialogContent, Typography, Box, Button, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IconHeartHandshake } from '@tabler/icons-react';

const SafetyPopup = ({ open, onClose }) => {
    const theme = useTheme();

    // Handler for "Get Support"
    const handleGetSupport = () => {
        
        setTimeout(() => {
            window.open('/crisis', '_blank', 'noopener,noreferrer');
            onClose('get_support');
        },500);
    };

    // Handler for "I'm Safe"
    const handleSafeDismiss = () => {
        // Close and signal 'dismissed' action
        onClose('dismissed');
    };

    return (
        <Dialog 
            open={open} 
            onClose={() => {}} // Forces button interaction
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    padding: 2,
                    borderTop: `6px solid ${theme.palette.warning.main}`
                }
            }}
        >
            <DialogContent>
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                    <IconHeartHandshake size={48} color={theme.palette.warning.main} stroke={1.5} />
                    
                    <Typography variant="h4" sx={{ mt: 2, mb: 1, fontWeight: 700 }}>
                        Just checking in
                    </Typography>

                    <Typography variant="body1" color="textSecondary" paragraph>
                        Our automated safety system flagged a potential suicidal concern in your most recent conversation. We want to ensure you have the support you need.
                    </Typography>

                    <Box sx={{ bgcolor: 'action.hover', p: 2, borderRadius: 2, mb: 3, width: '100%' }}>
                        <Typography variant="body1" fontWeight={600} gutterBottom mb={2}>
                            If you are in immediate danger, please call emergency services (911/999)
                        </Typography>
                        <Button
                            variant="outlined"
                            sx={{ fontWeight: 600 }}
                            onClick={handleGetSupport}
                        >
                            Get Support
                        </Button>
                    </Box>

                    <Typography variant="body2" color="textSecondary" sx={{ mb: 3, display: 'block' }}>
                        ZOSA & Artificial Intelligence isn't perfect. If you were just discussing a past experience or the system misunderstood the context, please close this window.
                    </Typography>

                    <Link variant="caption" color="textSecondary" href="/safety" target="_blank" rel="noopener" sx={{ mb: 3, display: 'block' }}>
                        Read more about safety with ZOSA
                    </Link>

                    <Button 
                        variant="outlined" 
                        color="warning" 
                        onClick={handleSafeDismiss}
                        sx={{ borderRadius: 2, py: 1.5, textTransform: 'none' }}
                    >
                        I'm safe
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default SafetyPopup;